import React from "react";
import Markdown from "markdown-to-jsx";
import PropTypes from "prop-types";
import "./prompt.scss";

const Prompt = ({ promptText }) => {
  return (
    <Markdown
      className="prompt"
      options={{
        overrides: {
          h1: {
            props: {
              className: "prompt__title"
            }
          },
          h2: {
            props: {
              className: "prompt__sub-title"
            }
          },
          h3: {
            props: {
              className: "prompt__section-title"
            }
          },
          strong: {
            props: {
              className: "prompt__section-title"
            }
          },
          ul: {
            props: {
              className: "prompt__list"
            }
          },
          a: {
            props: {
              target: "_blank",
              className: "prompt__link"
            }
          }
        }
      }}
    >
      {promptText}
    </Markdown>
  );
};

Prompt.propTypes = {
  promptText: PropTypes.string.isRequired
};

export default Prompt;
